// These formatters should now be used with the useFormatter hook to get the currency symbol
// For backward compatibility, we'll keep these as simple utility functions
export function formatCurrencyValue(value: number): string {
  if (value === 0) return '0.00'
  const sign = value < 0 ? '-' : ''
  return `${sign}${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatVarianceValue(value: number, isComparison = false): string {
  if (!isComparison) {
    return formatCurrencyValue(value)
  }

  if (value === 0) return '0.00'
  const sign = value > 0 ? '+' : '-'
  return `${sign}${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

// Legacy functions with hardcoded $ - deprecated
export function formatCurrency(value: number): string {
  if (value === 0) return '$0.00'
  const sign = value < 0 ? '-' : ''
  return `${sign}$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatVariance(value: number, isComparison = false): string {
  if (!isComparison) {
    return formatCurrency(value)
  }

  if (value === 0) return '$0.00'
  const sign = value > 0 ? '+' : '-'
  return `${sign}$${Math.abs(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export function formatCurrencyConsistent(value: number, precision = 2, currencySymbol = '$'): string {
  if (value === 0) return `${currencySymbol}0.${'0'.repeat(precision)}`
  const sign = value < 0 ? '-' : ''
  const formattedValue = Math.abs(value).toLocaleString('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
  return `${sign}${currencySymbol}${formattedValue}`
}

export function formatVarianceConsistent(
  value: number,
  precision = 2,
  currencySymbol = '$',
  isComparison = false
): string {
  if (!isComparison) {
    return formatCurrencyConsistent(value, precision, currencySymbol)
  }

  if (value === 0) return `${currencySymbol}0.${'0'.repeat(precision)}`
  const sign = value > 0 ? '+' : '-'
  const formattedValue = Math.abs(value).toLocaleString('en-US', {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
  return `${sign}${currencySymbol}${formattedValue}`
}
